import { putQueueItem } from 'actions'

export const updateQueueItem = async (payload) => {
  const res = await putQueueItem(payload)
  console.log('ACTION', payload)
  return {
    type: 'UPDATE_QUEUE_ITEM_SUCCESS',
    data: res.data
  }
}
